import type { SettingsTone } from "@/lib/carouselSettingsMeta";

export type StudioTone = SettingsTone;

export const STUDIO_TIPS = {
  pain: "Filtr korpusu. Puste = wszystkie bóle. Komentarz i Messenger nie muszą mieć odpowiednika w książce.",
  sku: "Gdzie prowadzi slajd zamykający. Domyślnie pakiet ebooków. Papier jest dodatkiem, nie osobnym celem karuzeli.",
  type: "Szablon slajdów. Pusty chip to mieszanka: model dobiera typy do 4 kątów. Jeden chip blokuje typ wszystkich kart.",
  style: "Paleta druku. Domyślnie płaski papier (Pillow). Gemini tylko gdy klikniesz tło Gemini. Polski tekst zawsze nakłada Pillow.",
  visualPack: "Rytm slajdów (hak / lista / vs / cytaty / karta), nie sam kolor. Ustawia też paletę z paczki. Puste = stara heurystyka.",
  book: "Opcjonalne źródło. Narzędzie filtruje tylko tę sekcję. Głos Kasi jest tu, gdy książka jest włączona.",
  bookWhich: "Który manuskrypt idzie do retrievera. Puste = wszystkie książki w katalogu.",
  tool: "Narzędzie z książki, nie musi pokrywać wybranego bólu. Puste = bez twardego filtra narzędzia.",
  comments: "Sceny z komentarzy pod rolkami. Osobny korpus, nie wymaga włączonej książki.",
  messenger: "Historie z DM. Osobny korpus, nie wymaga książki. PII zostaje w panelu, do LLM idzie oczyszczony fragment.",
  stories: "Czwarty korpus: kanon historyjek Kasi. Nie nadpisuje MOFU. Inbox dyktand nie idzie do modelu.",
  inspiration:
    "Permalink IG / FB / Pinterest. Studio próbuje ściągnąć slajdy i je przeczytać. Chipy decydują, co wolno wziąć (układ, pomysł, hierarchia). Kolory i rodzaj zdjęcia są wyłączone, dopóki ich nie włączysz. Krem Kasi zostaje podłogą.",
  note: "Krótka instrukcja operatora, np. ten vs, 7 slajdów, bez historyjki.",
  copyType: "Przed wyborem karty zmiana typu przebuduje 4 koncepcje. Po wyborze typ idzie tylko do generatora treści.",
  generateCopy: "Startuje panel ról i redaktora. Klik w kartę tylko zaznacza wybór, nic nie wysyła.",
  copyFeedback: "Twoja uwaga idzie do ról i redaktora przy Generuj ponownie albo Popraw po recenzji. Po poprawce dostajesz listę, co i jak zmieniła na kartach.",
  caption: "Wspólny korpus narracji (scena i rozwinięcie). Końcówki dokleja system: FB = link /k/…, IG = hasło „pakiet” w komentarzu. Nie na slajdach.",
  copyReview: "Role oceniają gotowe slajdy, nie koncepcję. Druga runda tylko po Twoim kliknięciu.",
  designReview:
    "Złóż obrazki składa kanon (zdania, grube hasła, lewa oś, strzałki, żółty marker tylko przy kontraście). Popraw serię woła pętlę i od razu stosuje werdykt (przepisy, oś, markery). Analiza układu (poproś, potem wdróż zaznaczone) jest osobną kartą pod paskiem.",
  copyStyle: "Styl tej konkretnej karuzeli. Zmień przed renderem. Nie rusza copy slajdów.",
  bgMode: "Druk: płaski papier + ziarno, bez API. Gemini: jedno tło na zestaw, tylko na żądanie. Zdjęcie z pickera zawsze wygrywa.",
  bgHint: "Krótka instrukcja do Gemini, np. ciepłe okno z lewej, Kasia z boku, bez kuchni. W składzie slajdu: Nowe tło Gemini generuje 3 warianty do wyboru. Zero liter na tle i tak obowiązuje.",
  bgCount: "Ile różnych teł Gemini narysuje. Domyślnie 1 na wszystkie slajdy. Każdy slajd psuje spójność zestawu.",
  hookVisual: "Slajd 1 to albo zdjęcie Kasi (jak jest), albo wielki tytuł na płaskim druku. Nie klimatyczne tło z małym napisem.",
  gemini: "Klucz Gemini. Bez niego koncepcje spadają na szablon. Tła slajdów i tak mogą iść drukiem (Pillow).",
  igPublish: "Scope instagram_content_publish. Bez niego kolejka działa, publikacja IG nie.",
  fbPublish: "Scope pages_manage_posts plus Page token. Unpublished zdjęcia na Page muszą iść jako strona, nie jako user.",
  queue: "Wstrzymana kolejka nie publikuje zaplanowanych karuzel. Szkice i render zostają.",
  mix: "4 kąty, często 4 typy. To nie znaczy zawsze historyjka.",
  allPains: "Bez filtra bólu. Retriever bierze trafienia ze wszystkich B w katalogu.",
  allBooks: "Bez filtra książki. Narzędzie nadal działa, jeśli je wybierzesz.",
  trackPick: "Nowy przebieg albo klik w utworzoną. Tory nie mieszają się na jednym briefie.",
  trackOwn: "Masz hak i ściany. Zredaguj: plan układu, potem ściany ze szkicu (słaby hak poprawia lokalnie).",
  trackAi: "Temat i korpus. System składa 4 koncepcje, Ty wybierasz kartę, potem copy.",
  changeTrack: "Zmiana toru czyści karty albo wstawiony tekst, żeby nie zostawić mieszanki.",
  slideMarkdown:
    "- albo * na starcie linii: lista, prefiks zostaje\n" +
    "**fraza** albo __fraza__: pogrubienie; pierwsza = żółty marker, gdy house chce\n" +
    "*fraza* albo _fraza_: kursywa\n" +
    "Podpis: bez gwiazdek\n" +
    "Na Przetwarzaniu: gwiazdki w Hasło i Opis. W składzie: B, I, U, M i Wypunktuj, nie gwiazdki.\n" +
    "Nie: # nagłówki, nie: [tekst](url)",
  ctaIntent: "Jedna prośba w podpisie. Wina i wstyd: zapisz. Granica i konflikt: wyślij. Lista pytań: komentarz. Chip nadpisuje rekomendację.",
  closeMode: "Gdzie stoi prośba. Domyślnie tylko w podpisie. Miękki: pudełko Zapisz/Wyślij bez ceny. Slajd: jedna prośba na ostatniej ścianie, nadal bez linku.",
  ab: "Opcjonalna para testowa. Jedna zmienna: hak, długość, okładka albo CTA. Nie porównuj jabłek z gruszkami.",
} as const;

export type CtaIntent = "save" | "send" | "comment";
export type CloseMode = "caption_only" | "soft_action" | "slide_cta";
export type AbVariable = "" | "hook" | "length" | "cover" | "cta";
export type BgMode = "flat" | "gemini";

export function recommendCta(painId: string, formatId: string): { cta_intent: CtaIntent; close_mode: CloseMode } {
  if (formatId === "question-list") return { cta_intent: "comment", close_mode: "caption_only" };
  if (formatId === "steps-save") return { cta_intent: "save", close_mode: "soft_action" };
  if (["B11", "B12", "B18"].includes(painId)) return { cta_intent: "send", close_mode: "soft_action" };
  if (["B1", "B4", "B5", "B9"].includes(painId)) return { cta_intent: "save", close_mode: "caption_only" };
  return { cta_intent: "save", close_mode: "caption_only" };
}

export const CTA_IO = {
  concepts: { take: "Weźmie brief, źródła i notatkę.", give: "Zwróci 4 karty koncepcji." },
  inspiration: { take: "Weźmie URL i chipy (układ, pomysł, hierarchia).", give: "Zwróci odczyt slajdów i plan, co wolno wziąć." },
  fromDraft: {
    take: "Weźmie wklejony szkic i (gdy puste) dobierze parametry ze treści.",
    give: "Najpierw plan układu, potem redakcja ścian (hak warstwa 1, lista/puenta).",
  },
  caption: {
    take: "Weźmie slajdy, szkic, opcjonalną uwagę i (gdy zaznaczone) manuskrypty SKU.",
    give: "Zwróci korpus opisu. Przy publikacji: FB + link /k/…, IG + hasło matka (ManyChat). Przy weryfikacji: werdykt i cytaty z książek.",
  },
  layoutPlan: { take: "Weźmie szkic albo wybraną kartę.", give: "Zwróci plan układu ścian." },
  copy: { take: "Weźmie wybraną kartę i uwagę.", give: "Zwróci slajdy i recenzję ról." },
  copyRevise: { take: "Weźmie recenzję i Twoją uwagę.", give: "Zwróci poprawione slajdy i listę zmian." },
  render: {
    take: "Weźmie zatwierdzone copy, styl i tło.",
    give: "Złoży PNG: zdania zamiast VERSALIKÓW, grube hasła, lewą oś, strzałki i żółty marker tylko przy kontraście.",
  },
  layoutQa: { take: "Weźmie złożone slajdy.", give: "Zwróci werdykt składu albo listę poprawek." },
  designReview: { take: "Weźmie serię slajdów.", give: "Zwróci ręczną turę dyrektorki (smak: marker i kadr)." },
  designApply: { take: "Weźmie zatwierdzone rekomendacje smaku.", give: "Zwróci nowy skład po zatwierdzeniu markera albo kadru." },
  houseFix: { take: "Weźmie już złożoną serię.", give: "Złoży kanon i zastosuje werdykt: przepisy, oś, markery, strzałki." },
  retro: { take: "Weźmie opublikowaną karuzelę i metryki.", give: "Zwróci lekcję do zatwierdzenia." },
  publish: { take: "Weźmie PNG, podpis i proponowany slot.", give: "Wstawi post do Graph albo do kolejki na tę godzinę." },
  post: { take: "Weźmie ten sam brief.", give: "Zwróci jeden post 1-grafika, nie karuzelę." },
  reel: { take: "Weźmie PNG slajdów i utwór z Epidemic.", give: "Złoży rolkę 9:16 z muzyką. FB dostanie rolkę, IG zostaje karuzelą." },
} as const;

export type CtaIoKey = keyof typeof CTA_IO;

export type StudioTab = "brief" | "draft" | "copy" | "render" | "publish";

const HASH_TO_TAB: Record<string, StudioTab> = {
  brief: "brief",
  draft: "draft",
  szkic: "draft",
  copy: "copy",
  concepts: "copy",
  render: "render",
  slides: "render",
  publish: "publish",
};

export function studioTabFromHash(hash: string): StudioTab {
  const key = (hash || "").replace(/^#/, "").split("?")[0];
  return HASH_TO_TAB[key] || "brief";
}

export function studioTabToHash(tab: StudioTab): string {
  if (tab === "draft") return "#szkic";
  return `#${tab}`;
}

export const STUDIO_TAB_META: {
  id: StudioTab;
  label: string;
  hint: string;
  stageIds: string[];
}[] = [
  {
    id: "brief",
    label: "Wejście",
    hint: "Szkic na górze. Parametry opcjonalne: system dobierze ze szkicu, jeśli nic nie klikniesz.",
    stageIds: ["params"],
  },
  {
    id: "draft",
    label: "Szkic",
    hint: "Zredaguj slajdy: prompt, strzały modelu, funkcje lokalne i wynik każdego kroku.",
    stageIds: ["copy"],
  },
  {
    id: "copy",
    label: "Przetwarzanie",
    hint: "Koncepcje i teksty. Tu czekasz, recenzujesz i poprawiasz copy.",
    stageIds: ["concepts", "copy"],
  },
  {
    id: "render",
    label: "Wyjście",
    hint: "Obrazki, opis i recenzja designu. Tu zatwierdzasz skład.",
    stageIds: ["images"],
  },
  {
    id: "publish",
    label: "Publikacja",
    hint: "Najbliższy wolny slot (wt/śr/pt 10:00), Graph i kolejka.",
    stageIds: ["publish", "retro"],
  },
];

export function tabStateFromPipeline(
  pipeline: { stages?: { id: string; state: string }[] } | null | undefined,
  stageIds: string[],
): string {
  const rank: Record<string, number> = { error: 5, active: 4, waiting: 3, blocked: 2, done: 1 };
  let best = "";
  let bestRank = 0;
  for (const stage of pipeline?.stages || []) {
    if (!stageIds.includes(stage.id)) continue;
    const n = rank[stage.state] || 0;
    if (n > bestRank) {
      best = stage.state;
      bestRank = n;
    }
  }
  return best || "waiting";
}

export const STATUS_TIPS: Record<string, string> = {
  idea: "Są koncepcje albo brief. Nie wybrano jeszcze jednej karty.",
  draft: "Szkic albo wybrana koncepcja. Typ i styl możesz jeszcze zmienić.",
  approved: "Copy zatwierdzone. Można renderować i planować.",
  scheduled: "Czeka na godzinę publikacji.",
  publishing: "Graph w toku.",
  published: "Wisi na IG albo FB.",
  failed: "Publikacja albo render się wyłożyły.",
};

export const SOURCE_EMPTY = {
  book: "Brak fragmentów książki / głosu przy tym wyborze.",
  comments: "Brak trafień w komentarzach przy tym bólu.",
  messenger: "Brak trafień w Messengerze przy tym bólu.",
  stories: "Brak historyjek przy tym bólu (B6, B7, B15, B16, B17, B18, B19, B10, B12).",
} as const;

export type HouseCanonRow = { key: string; ok: boolean; label: string };

type HouseScoreLike = {
  ok?: boolean;
  fails?: Record<string, number[]>;
};

type HouseReviewLike = {
  house_score?: HouseScoreLike;
  loop?: { turns?: { after_score?: HouseScoreLike; now_score?: HouseScoreLike }[] };
};

export function houseScoreOf(review?: HouseReviewLike | null): HouseScoreLike | undefined {
  if (review?.house_score) return review.house_score;
  const turns = review?.loop?.turns || [];
  const last = turns[turns.length - 1];
  return last?.after_score || last?.now_score;
}

export function houseCanonState(review?: HouseReviewLike | null, hasSlides = false) {
  const score = houseScoreOf(review);
  const hasLoop = Boolean(review?.loop?.turns?.length);
  const stale = hasSlides && !score && !hasLoop;
  const fails = score?.fails || {};
  const fail = (key: string) => (fails[key] || []).length > 0;
  const rows: HouseCanonRow[] = [
    { key: "versals", ok: !fail("versals"), label: fail("versals") ? "Hasła: plakat na PNG" : "Hasła: zdanie" },
    { key: "axis", ok: !fail("axis_off"), label: fail("axis_off") ? "Oś: nie lewo" : "Oś: lewo" },
    { key: "bold", ok: !fail("thin_heading"), label: fail("thin_heading") ? "Hasła cienkie" : "Hasła grube" },
    { key: "arrow", ok: !fail("arrow_off_paper"), label: fail("arrow_off_paper") ? "Strzałki poza papierem" : "Strzałki na papierze" },
    { key: "marker", ok: !fail("markers_jump"), label: fail("markers_jump") ? "Marker: zły / brak" : "Marker: przy kontraście" },
    { key: "dup", ok: !fail("dup_lines"), label: fail("dup_lines") ? "Linie: powtórzenie" : "Linie: raz" },
    { key: "list", ok: !fail("list_bare"), label: fail("list_bare") ? "Lista: ikony" : "Lista: myślniki" },
    { key: "example", ok: !fail("example_unnumbered"), label: fail("example_unnumbered") ? "Przykłady: bez numeru" : "Przykłady: 1. 2. 3." },
    { key: "overlap", ok: !fail("boxes_overlap"), label: fail("boxes_overlap") ? "Tekst: nachodzi" : "Tekst: bez nachodzenia" },
  ];
  return { stale, score, ok: Boolean(score?.ok), rows, hasSlides };
}
